"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var comparison_1 = require("./features/comparison");
var metricValue_1 = require("./features/metricValue");
var status_1 = require("./features/status");
var threshold_1 = require("./features/threshold");
var models_1 = require("./models");
var EffectiveDefinition_1 = require("./models/EffectiveDefinition");
var DefinitionBuilder = /** @class */ (function () {
    function DefinitionBuilder(def) {
        var _this = this;
        this.build = function () {
            return _this.def;
        };
        this.withHistoricalComparison = function (dateTrunc, numberOfPeriods, hideComparisonLine) {
            if (dateTrunc === void 0) { dateTrunc = models_1.DateTrunc.DAY; }
            if (numberOfPeriods === void 0) { numberOfPeriods = 1; }
            if (hideComparisonLine === void 0) { hideComparisonLine = false; }
            var legacyComparison = {
                type: 'HISTORICAL_COMPARISON',
                comparisonPeriod: dateTrunc,
                numberOfPeriods: numberOfPeriods,
                message: '',
            };
            _this.def = comparison_1.definitionWithComparison(_this.def, legacyComparison, hideComparisonLine);
            return _this;
        };
        this.withStaticTarget = function (constant) {
            _this.def = threshold_1.definitionWithStaticTarget(_this.def, constant);
            return _this;
        };
        this.withStatus = function (status) {
            _this.def = status_1.definitionWithStatus(_this.def, status).unwrap();
            return _this;
        };
        this.def = def;
        return this;
    }
    return DefinitionBuilder;
}());
exports.DefinitionBuilder = DefinitionBuilder;
exports.simpleDefinition = function (dateGranularity) {
    if (dateGranularity === void 0) { dateGranularity = models_1.DateGranularity.DAY; }
    return new DefinitionBuilder({
        schema: {
            measure: {
                name: metricValue_1.MEASURE_COLUMN_NAME,
                type: EffectiveDefinition_1.NumberType,
            },
            timestamp: {
                name: metricValue_1.TIMESTAMP_COLUMN_NAME,
                type: EffectiveDefinition_1.DateTimeType,
                dateGranularity: dateGranularity,
            },
        },
        features: {
            measure: { column: metricValue_1.MEASURE_COLUMN_NAME },
            timestamp: { column: metricValue_1.TIMESTAMP_COLUMN_NAME },
        },
        tableTransforms: {},
    });
};
//# sourceMappingURL=DefinitionBuilder.js.map